<template>
  <transition name="modal">
    <modal class="xls-import xls-import-modal" :redesign="true" :small="true" @close="close">
      <div slot="header" class="title">
        {{ $tr('invites.invite.importFromExcel') }}
      </div>

      <div slot="body" class="top-label-form">
        <p>{{ $tr('invites.invite.selectFile') }}</p>
        <template v-if="file === null">
          <input
            id="excelUpload"
            type="file"
            class="excel-upload"
            accept=".xlsx, .xls"
            @change="handleSelectedFiles($event.target.files)"
          />
          <label for="excelUpload" class="upload-button">
            {{ $tr('invites.invite.import') }}
          </label>
        </template>
        <template v-else>
          <div class="row-block">
            <div class="file-name">{{ file.name }}</div>
            <span class="icon icon-cancel" @click="deleteFile"></span>
          </div>
        </template>
        <p>{{ $tr('invites.invite.selectVacancy') }}</p>
        <multiselect
          v-model="vacancy"
          class="boxy"
          :options="list_dropdown"
          :show-labels="false"
          :allow-empty="false"
          :searchable="true"
          :loading="loading_more"
          track-by="id"
          label="name"
          :placeholder="$tr('vacancies.placeholders.selectVacancy')"
          @open="selectOpened = true"
          @search-change="asyncFind"
          @close="selectOpened = false"
        >
          <span slot="noResult">{{ $tr('vacancies.placeholders.notFound') }}</span>
          <template v-if="vacancies_total > list_dropdown.length" slot="afterList">
            <div class="after-list">
              <vbutton
                :text="$tr('select.button.more')"
                :disabled="loading_more"
                :loading="loading_more"
                @click="load_more"
              />
            </div>
          </template>
        </multiselect>
      </div>

      <div slot="footer" class="footer-row">
        <vbutton
          class="button-margin"
          label="invites.invite.accept"
          :disabled="!canBeImport"
          @click="importInvites"
        />
        <vbutton class="button-margin" label="invites.invite.cancel" color="white" @click="close" />
      </div>
    </modal>
  </transition>
</template>

<script>
  import debounce from 'debounce';
  import Modal from '@/components/Modal.vue';

  export default {
    name: 'XlsImportInvitesModal',

    components: {
      Modal
    },

    data() {
      return {
        vacancy: null,
        file: null,
        selectOpened: false,
        loading_more: false,
        searchTerm: '',
        count: 20
      };
    },

    computed: {
      ...mapState('vacancies', ['list_dropdown', 'vacancies_total']),

      canBeImport() {
        return this.file && this.vacancy && !this.selectOpened;
      },

      company() {
        return this.$store.getters['company/one'];
      }
    },

    beforeMount() {
      this.CHANGE_PAGINATION_COUNT(20);
    },

    beforeDestroy() {
      this.CHANGE_PAGINATION_COUNT(20);
    },

    methods: {
      ...mapMutations('vacancies', ['CHANGE_PAGINATION_COUNT']),
      ...mapActions('vacancies', ['fetchVacanciesListDropdown']),
      close() {
        this.$emit('close');
      },

      fetch() {
        this.loading_more = true;
        let params = {
          searchTerm: this.searchTerm
        };

        this.fetchVacanciesListDropdown(params)
          .then(() => {
            this.loading_more = false;
          })
          .catch(() => {
            this.loading_more = false;
          });
      },

      asyncFind: debounce(function (v) {
        this.searchTerm = v;
        this.fetch();
      }, 500),

      load_more(is_active = true) {
        this.count = this.count + 20;
        this.CHANGE_PAGINATION_COUNT(this.count);
        this.fetch();
      },

      deleteFile() {
        this.file = null;
      },

      handleSelectedFiles(files) {
        if (!files[0]) {
          return null;
        }

        this.file = files[0];
      },

      importInvites() {
        this.$store
          .dispatch('invites/creation/importFromFile', {
            file: this.file,
            vacancy: this.vacancy
          })
          .catch(e => {
            console.log(1, JSON.parse(JSON.stringify(e)));
          });
        this.close();
      }
    }
  };
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.xls-import {
  .title {
    margin: 0 auto;
    font-size: 20px;
    text-align: center;
  }

  .top-label-form {
    // width: 400px;

    .row-block {
      border-bottom: 1px solid #d9d9d9;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 12px;

      .file-name {
        color: $green;
        font-size: 16px;
      }

      .icon-cancel {
        color: gray;
        cursor: pointer;

        &:hover {
          color: black;
        }
      }
    }
  }

  .upload-button {
    border-radius: 5px;
    border: 1px solid $green;
    border-style: dashed;
    width: 100%;
    text-align: center;
    color: $green;
    padding: 14px 0 12px;
    margin: 0 auto;
    cursor: pointer;
  }

  .multiselect {
    max-width: 100%;
  }

  .excel-upload {
    display: none;
  }

  .footer-row {
    display: flex;
    width: 400px;

    .vcv-button {
      margin-left: 0;

      &.transparent {
        margin-left: 20px;
        border: none;
        padding: 0;
        min-width: initial;
        background: transparent;
        color: $green;
      }
    }
  }
}

.button-margin {
  margin-right: 15px;
}

.xls-import-modal {
  ::v-deep {
    .after-list {
      padding: 10px;
      border-top: 1px solid #ccc;
      margin-top: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
